import {createContext} from "react"
import {SHOP_DATA} from "./shopData";

export const ShopDataContext = createContext(SHOP_DATA)
